export type RelationshipSituation =
  | 'Unspecified'
  | 'Single'
  | 'Married'
  | 'CivilUnion'
  | 'Concubinage'
  | 'Separated'
  | 'Divorced'
  | 'Widowed';

export const relationshipSituationOptions: Array<{ value: RelationshipSituation; label: string }> = [
  { value: 'Unspecified', label: 'No especificado' },
  { value: 'Single', label: 'Soltero/a' },
  { value: 'Married', label: 'Casado/a' },
  { value: 'CivilUnion', label: 'Unión convivencial' },
  { value: 'Concubinage', label: 'Concubinato' },
  { value: 'Separated', label: 'Separado/a' },
  { value: 'Divorced', label: 'Divorciado/a' },
  { value: 'Widowed', label: 'Viudo/a' },
];

export const relationshipSituationLabels: Record<RelationshipSituation, string> = Object.fromEntries(
  relationshipSituationOptions.map(option => [option.value, option.label]),
) as Record<RelationshipSituation, string>;
